// extracted by mini-css-extract-plugin
module.exports = {"header":"_1771f418","heading":"_ae8e2b4f","companyInfo":"_d25f606e","ratingContainer":"_5f60cf07"};